import { Text } from "@volca/ui/components/ui/text";
import type { ApPurchaseDocument } from "@/accounts-payable/types";
import { formatApZonedDateTime } from "@/accounts-payable/utils";
import { useApBusinessTimeZone } from "./use-ap-business-time-zone";

export const DocumentTimestamps = ({
  document,
}: {
  document: Pick<
    ApPurchaseDocument,
    "created_at" | "review_state" | "reviewed_at"
  >;
}) => {
  const timeZone = useApBusinessTimeZone();
  const added = formatApZonedDateTime(document.created_at, timeZone);
  const reviewed =
    document.review_state === "reviewed"
      ? formatApZonedDateTime(document.reviewed_at, timeZone)
      : undefined;
  const parts = [added && `Added ${added}`, reviewed && `Reviewed ${reviewed}`];
  const text = parts.filter(Boolean).join(" · ");
  if (!text) return null;

  return (
    <Text variant="caption" tone="muted">
      {text}
    </Text>
  );
};
